const PaymentTypeSelect = ({ value, onPaymentTypeChange, disabled }) => (
    <div className="formField">
        <label>Payment Type:</label>
        <select 
            value={value || 'minimum'} 
            onChange={onPaymentTypeChange}
            disabled={disabled}
            style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem'
            }}
        >
            <option value="minimum">Minimum</option>
            <option value="fixed">Fixed</option>
        </select>
    </div>
)

export default PaymentTypeSelect